import { render, staticRenderFns } from "./isDeHe.vue?vue&type=template&id=cc379056&scoped=true&"
import script from "./isDeHe.vue?vue&type=script&lang=js&"
export * from "./isDeHe.vue?vue&type=script&lang=js&"
import style0 from "./isDeHe.vue?vue&type=style&index=0&id=cc379056&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc379056",
  null
  
)

export default component.exports